"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Dialog/index"), exports);
var index_1 = require("./components/Dialog/index");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return index_1.Dialog; } });
//# sourceMappingURL=Dialog.js.map